import { NgModule } from '@angular/core';
import { Routes, RouterModule, ExtraOptions } from '@angular/router';
import { AdminComponent } from './page/admin/admin.component';
import { DashboardComponent } from './page/dashboard/dashboard/dashboard.component';
import { MemberComponent } from './page/dashboard/member/member.component';
import { ReportComponent } from './page/dashboard/room/report/report.component';
import { RoomComponent } from './page/dashboard/room/room.component';
import { StationComponent } from './page/dashboard/station/station.component';
import { HomeComponent } from './page/home/home.component';
import { LoginComponent } from './page/login/login.component';
import { ProcessComponent } from './page/process/process.component';
import { SettingComponent } from './page/dashboard/setting/setting.component';
import { AuthGuard } from './guards/auth.guard';

const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'home', component: HomeComponent },
  { path: 'process', component: ProcessComponent },
  { path: 'process/:id', component: ProcessComponent },
  { path: 'login', component: LoginComponent },
  // Protected routes with AuthGuard
  { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard] },
  { path: 'room', component: RoomComponent, canActivate: [AuthGuard] },
  { path: 'admin', component: AdminComponent, canActivate: [AuthGuard] },
  { path: 'member', component: MemberComponent, canActivate: [AuthGuard] },
  { path: 'station', component: StationComponent, canActivate: [AuthGuard] },
  { path: 'setting', component: SettingComponent, canActivate: [AuthGuard] },
  { path: 'report', component: ReportComponent, canActivate: [AuthGuard] },
  // Wildcard route for 404 page
  { path: '**', redirectTo: '/home' }
];

const routerOptions: ExtraOptions = {
  useHash: true,
  anchorScrolling: 'enabled',
  onSameUrlNavigation: "reload",
  scrollPositionRestoration: "enabled"
};
@NgModule({
  imports: [RouterModule.forRoot(routes,routerOptions)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
